(function () {
  const VIEWPORT_MARGIN = 8;
  const TOOLTIP = '[data-tooltip]';
  const TRIGGER = '[data-tooltip-trigger]';
  const CONTENT = '[data-tooltip-content]';

  function position(tooltip) {
    const content = tooltip.querySelector(CONTENT);
    if (!content) return;

    content.style.setProperty('--tooltip-shift', '0px');

    const rect = content.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;

    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }

    content.style.setProperty('--tooltip-shift', shift + 'px');
  }

  function close(tooltip) {
    tooltip.classList.remove('is-open');
    const trigger = tooltip.querySelector(TRIGGER);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll(TOOLTIP + '.is-open').forEach(function (tooltip) {
      if (tooltip !== except) close(tooltip);
    });
  }

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const trigger = target.closest(TRIGGER);
    const tooltip = trigger && trigger.closest(TOOLTIP);

    if (!tooltip) {
      if (!target.closest(TOOLTIP)) closeAll(null);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const willOpen = !tooltip.classList.contains('is-open');
    closeAll(tooltip);
    tooltip.classList.toggle('is-open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) position(tooltip);
  });

  document.addEventListener(
    'mouseover',
    function (event) {
      const target = event.target instanceof Element ? event.target : null;
      const tooltip = target && target.closest(TOOLTIP);
      if (tooltip) position(tooltip);
    },
    { passive: true }
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  window.addEventListener(
    'resize',
    function () {
      closeAll(null);
    },
    { passive: true }
  );
})();
